import { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query';

import { fetchAll, fetchAllWithCount, fetchOne } from '../../lib/v31lib';
import { loginAtom } from '../../lib/auth';
// import { checkAllowed } from '../../lib/permission';

import LaunchIcon from '@mui/icons-material/Launch';

// import {
//   CircularProgress
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import { getCookie, setCookie } from 'react-use-cookie';

import {
  DataGrid,
  Dt,
  Page,
  SearchBox,
  StyledIconButton,
  Typography
} from '../../components/interface';

import { OrganiserLog } from '../../models/OrganiserLog';

// const { DateTime } = require("luxon");

type Props = {};

export const AdminOrganiserLogs: FunctionComponent<Props> = () => {
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);

  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  const [activeCompany, setActiveCompany] = useState<string>(getCookie('panelmetrics_active_company_id') || '');
  let count = 0;
  const [status, setStatus] = useState<string[]>();


  const {
    data: objects,
    isLoading: objectsLoading,
    // isError: bookYearsError,
    // isSuccess: bookYearsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["organiser_logs", activeCompany, {page: page, order: order, status: status}],
    queryFn: () =>
      fetchAllWithCount<OrganiserLog>(
        "/nl/v3/objects/fetch_all",
        {
          object: "organiser_log",
          fields: [
            "id", 'created_at', 'user', 'company', 'action_key', 'extra_data'
          ],
          sub_fields: {
            'company': ['id', 'name', 'get_item'],
            'user': ['id', 'first_name', 'last_name']
          },
          order: order,
          page: page,
          per_page: 20,
          filter: {
            search: '',
            advanced: {
              company_id: activeCompany,
              action_keys: status
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!login && !!activeCompany
  });


  useEffect(() => {
    console.log(status);
  }, [status]);

  





  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 100, sortable: true },
    { field: 'company_name', headerName: 'Company', width: 200, sortable: false },
    { field: 'user_name', headerName: 'User', width: 200, sortable: false },
    { field: 'created_at', headerName: 'Time', width: 200, sortable: true, renderCell: params => <>
      {!!params.row?.created_at && <Dt d={params.row.created_at} f="d LLLL y - t" />}
    </> },
    { field: 'action_key', headerName: 'Action', width: 200, sortable: false, renderCell: params => <>
      <Typography sx={{fontSize: '0.9rem'}}>{params.row.action_key}{params.row.action_key === 'toggle_archived' && <><br/>({params.row.extra_data.archived_was.toString()} -&gt; {params.row.extra_data.archived_is.toString()})</>}</Typography>
    </> },
  ];

  return (
    <Page sx={{}} title={t("objects.organiser_logs.title")}>
      {!activeCompany && <Typography>Select a company in the sidebar</Typography>}
      {!!activeCompany && <>
        <SearchBox
          // simple={true}
          transferSearch={(z) => {
            setPage(0);
            setStatus(z.status);
            // objectsRefetch();
          }}
          memo="stock_transfers"
        />

        <DataGrid
          action_count={1}
          actions={(params) => {
            return (<>
              {/* {checkAllowed(login, params.row.company_id?.toString() || '0', params.row.id.toString(), "Projects", 'u') && <StyledIconButton title="Edit" color="primary" path={`/project/${params.row.id}`}>
                <EditIcon />
              </StyledIconButton>} */}
              {params.row.action_key === 'pull_report' && <StyledIconButton title="GoTo" color="primary" path={`/report_versions/${params.row.extra_data?.report_id}`}>
                <LaunchIcon />
              </StyledIconButton>}
              {params.row.action_key === 'toggle_archived' && <StyledIconButton title="GoTo" color="primary" path={`/userinvites?filter=${params.row.extra_data?.user_invite_id}`}>
                <LaunchIcon />
              </StyledIconButton>}
            </>);
          }}
          getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
          objectCount={count}
          objects={(objects || []).map(u => ({
            ...u,
            company_name: u.company?.name,
            user_name: [u.user?.first_name, u.user?.last_name].join(" ")
          }))}
          columns={columns}
          loader={objectsLoading}
          onSortModelChange={(a, b) => {
            let a_0_field:string = a[0].field;
            setOrder([a_0_field, a[0].sort].join(' '));
          }}
          page={page}
          setPage={(p) => {setPage(p);}}
        />

        {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
      </>}
    </Page>
  );
}
